import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate/dist/types/components/Provider';

interface IMixinDialog extends Vue {
  listenBus: boolean;
  ghost: boolean;
  automatedOpen: boolean;
  allowRedirect: boolean;

  open(...args: any): void;
  close(...args: any): void;
}

@Component<IMixinDialog>({})
export default class MixinDialog extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
    form: any;
  };

  @Prop([Boolean]) readonly listenBus!: boolean;
  @Prop([Boolean]) readonly ghost!: boolean;
  @Prop([Boolean]) readonly automatedOpen!: boolean;
  @Prop([Boolean]) readonly allowRedirect!: boolean;

  dialog = false;

  clear() {
    if (this.$refs.form) {
      this.$refs.form.reset();
    }
    if (this.$refs.observer) {
      this.$refs.observer.reset();
    }
  }

  open(...args: any) {
    this.dialog = true;
  }

  close(...args: any) {
    this.clear();
    this.dialog = false;
  }
}
